import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import useMedia from "../componentsofcourse/useMedia";
//import '../Assets/css/dropdown.css'
// import dashboard_img from "../Assets/img/Home/dashboard.png";
import styles from "../Assets/css/Dropdown.module.css";
function Submenu(props) {
	const [subnav, setsubnav] = useState(false);
	const { token, admin } = props;
	return (
		<>
			<div
				className={styles.dropdowns}
				style={{ right: props.value == "logged in" && "2%" }}
			>
				<ul
					className={
						styles.items + " " + styles.round + "container-fluid"
					}
					style={{ paddingLeft: "0px", paddingRight: "0px" }}
				>
					{props.value == "logged in" && (
						<>
							<div className={"row " + styles.back}>
								<Link
									className="col-lg-12"
									style={{ height: "100%" }}
									to={`/user/${props.user_id}`}
								>
									<li className={styles.items}>
										<i class="fas fa-user-circle"></i>{" "}
										Profile{" "}
									</li>
								</Link>
							</div>
							<div className={"row " + styles.back}>
								<Link
									className="col-lg-12"
									style={{ height: "100%" }}
									to={`/internal-form`}
								>
									<li className={styles.items}>
										<i class="fas fa-user-circle"></i>{" "}
										Attendance{" "}
									</li>
								</Link>
							</div>
						</>
					)}

					{admin == true && (
						<div className={"row " + styles.back}>
							<Link
								className="col-lg-12"
								style={{ height: "100%" }}
								to="/addblog"
							>
								<li className={styles.items}>
									<i class="fas fa-blog"></i> Add Blog
								</li>
							</Link>
						</div>
					)}
					{admin == true && (
						<div className={"row " + styles.back}>
							<Link
								className="col-lg-12"
								style={{ height: "100%" }}
								to="/createJobPosting"
							>
								<li className={styles.items}>
									<i class="fas fa-blog"></i> Add JobPosting
								</li>
							</Link>
						</div>
					)}
					{
						props.value != "logged in" ? (
							<div className={"row " + styles.back}>
								<Link
									className="col-lg-12"
									style={{ height: "100%" }}
									to="/cpcourse"
								>
									<li className={styles.items}>
										Competitive Programming
									</li>
								</Link>
							</div>
						) : null
						/* <div className={ "row " + styles.back}>
            </div>} */
					}
					{props.value != "logged in" ? (
						<div className={"row " + styles.back}>
							<Link
								className="col-lg-12"
								style={{ height: "100%" }}
								to="/placementcourse"
							>
								<li className={styles.items}>
									Get Placement Ready
								</li>
							</Link>
						</div>
					) : (
						<div
							className={"row " + styles.back}
							onClick={() => {
								props.LogoutMethd();
							}}
						>
							<button
								className="col-lg-12"
								onClick={props.logout}
							>
								<li className={styles.items}>
									<i class="fas fa-sign-out-alt"></i> Log out
								</li>
							</button>
						</div>
					)}
				</ul>
			</div>
		</>
	);
}
export const DropdownComp = (props) => {
	//alert(props.props)
	const matches = useMedia("(min-width : 768px )");
	const [click, setclick] = useState(true);
	const handleClick = () => setclick(!click);
	const { token, admin } = props;

	const MenuItems = [
		{
			title: "Competitive Programming",
			path: "/cpcourse",
			cName: "dropdown-link",
		},
		{
			title: "Get placement Ready",
			path: "/placementcourse",
			cName: "dropdown-link",
		},
	];

	return (
		<>
			{useMedia == false ? (
				<div
					className={styles.dropdowns}
					style={{ width: "fit-content" }}
				>
					<ul
						className={
							styles.round + " container-fluid " + styles.items
						}
						style={{ paddingLeft: "0px", paddingRight: "0px" }}
					>
						<div className={"row " + styles.back}>
							<Link className="col-lg-12" to="/cpcourse" id="cp">
								<li className={styles.items}>
									Competitive Programming
								</li>
							</Link>
						</div>
						<div className={"row " + styles.back}>
							<Link
								className="col-lg-12"
								to="/placementcourse"
								id="gpr"
							>
								<li
									style={{ fontSize: "1.2rem" }}
									className={styles.items}
								>
									placement course
								</li>
							</Link>
						</div>
					</ul>
				</div>
			) : (
				<Submenu
					admin={admin}
					token={token}
					value={props.props}
					name={props.name}
					LogoutMethd={props.LogoutMethd}
					user_id={props.user_id}
				/>
			)}

			{/* <ul onClick={handleClick} className = {click ? 'dropdown-menu clicked' : 'dropdown-menu'}>
              {MenuItems.map((item,index) =>{
                    return (
                        <li key = {index}>
                        <Link className={item.cName} to={item.path} onClick={()=>setclick(false)}>
                            {item.title}
                        </Link>
                        </li>
                    )
                })}
            </ul> */}
		</>
	);
};
